(function () {
  if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) return;

  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const mainAtc = document.querySelector('product-form button[name="add"], product-form button[type="submit"]');
  if (!mainAtc) {
    bar.hidden = false;
    bar.setAttribute('data-sticky-atc-visible', 'true');
    return;
  }

  bar.hidden = false;

  const obs = new IntersectionObserver((entries) => {
    for (const e of entries) {
      bar.setAttribute('data-sticky-atc-visible', e.isIntersecting ? 'false' : 'true');
    }
  }, { threshold: 0.05 });

  obs.observe(mainAtc);

  document.addEventListener('variant:change', (ev) => {
    const variant = ev.detail && ev.detail.variant;
    if (!variant) return;
    const priceEl = bar.querySelector('[data-sticky-atc-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    const submit = bar.querySelector('button[type="submit"]');
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  });

  function formatMoney(cents) {
    const v = (cents / 100).toFixed(2);
    return '$' + v;
  }
})();
